import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CANADIAN_DAT_TIPS_CONFIG = enabledOn(PlatformSlug.DATCrusher)

export const isCanadianDatTipsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CANADIAN_DAT_TIPS_CONFIG, slug)
